module.exports = "/assets/site/images/pingpong.jpg?6bc5a80b977ab186133d438a7d1b3723";